import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Withdrawal from 'components/Credit24/SelfService/Withdrawal';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  contract: PropTypes.object,
  sendDrawAmount: PropTypes.func,
  isUpgradeHighlighted: PropTypes.bool,
};

class WithdrawalSection extends Component {
  constructor() {
    super();
    this.state = {
      withdrawalRef: null,
    };
    this.setSectionRef = this.setSectionRef.bind(this);
  }

  setSectionRef(node) {
    this.setState({
      withdrawalRef: node,
    });
  }

  render() {
    const {
      authentication,
      contract,
      selfservice,
      sendDrawAmount,
      isUpgradeHighlighted,
    } = this.props;

    const { isNativeAdvertisingEnabled } = selfservice;

    if (!contract.id) {
      return null;
    }

    let header = <FormattedMessage tagName="p" id="selfservice.dashboard.withdraw" />;
    if (COUNTRY !== 'AU') {
      if (contract.canFreeDraw && isNativeAdvertisingEnabled) {
        header = (
          <div className="withdrawal-section-header">
            <FormattedMessage id="selfservice.dashboard.freedraw">
              {(txt) => (<h3 className="withdrawal-section-header__freedraw">{txt}</h3>)}
            </FormattedMessage>
            <FormattedMessage id="selfservice.dashboard.withdraw">
              {(txt) => (<span className="withdrawal-section-header__title">{txt}</span>)}
            </FormattedMessage>
          </div>
        );
      }
    }

    return (
      <div className="content-block" ref={this.setSectionRef}>
        {!contract.drawBlockedReason && header}
        <Withdrawal
          bankAccount={authentication.bankAccount}
          contract={contract}
          selfservice={selfservice}
          sendDrawAmount={sendDrawAmount}
          withdrawalRef={this.state.withdrawalRef}
          isUpgradeHighlighted={isUpgradeHighlighted && isNativeAdvertisingEnabled}
          customerNumber={authentication.customerNumber}
        />
      </div>
    );
  }
}

WithdrawalSection.propTypes = propTypes;

export default WithdrawalSection;
